import { SelectionProviderToken } from "../../types/customization/configuration";
import { SelectionPhoto, SelectionProvider, SelectionState } from "../../types/selection/selection";

class PhotoNotFoundError extends Error {}

export function findPhoto(photoKey: string, selection: SelectionState): SelectionPhoto {
  const photo = selection.photos.find(({ key }) => key === photoKey);

  if (!photo) {
    throw new PhotoNotFoundError(`Photo not found for key "${photoKey}"`);
  }

  return photo;
}

export function isPhotoInPicturesList(
  selectionPhoto: SelectionPhoto,
  photoList: Array<{ key: string; providerRef: string }>
): boolean {
  return !!photoList.find(
    (photoKeys) =>
      photoKeys.providerRef === selectionPhoto.providerRef || photoKeys.key === selectionPhoto.key
  );
}

export function selectionProviderTokenFor(
  provider: SelectionProvider,
  selectionProviderTokens: SelectionProviderToken[]
): string | undefined {
  if (provider === "instagram") {
    const instagramSelectionProviderToken = localStorage.getItem("instagram");
    return instagramSelectionProviderToken ? instagramSelectionProviderToken : undefined;
  } else {
    const selectionProviderToken = selectionProviderTokens.find((s) => s.provider === provider);

    if (!selectionProviderToken) {
      return;
    }

    return selectionProviderToken.token;
  }
}
